import React, { useState, useEffect, useContext } from "react";
import "./AgentPayment.css";
import axios from "axios";
import { Link } from "react-router-dom";
// import SideBar from "../components/Sidebar/SideBar";
import AgentSide from "../agentcompo/AgentSide";
import Select from "react-select";
import { AgentContext } from "../context/agentcontext";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import userimage from "./images/userimage.png"

const Agentpaymentcollection = () => {
  const usernamedashboard = localStorage.getItem("username");
  const [groupName, setGroupName] = useState("");
  const [selectedOption, setSelectedOption] = useState(null); // New state for selected option

  const [transactions, setTransactions] = useState([]);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const { agentname } = useContext(AgentContext);
  const [user, setuser] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const [role, setRole] = useState("");
  const [usersname, setUsersname] = useState("");

  

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!groupName) {
      alert("Please fill in all input fields.");
      return;
    }
    try {
      const response = await axios.post("http://localhost:5001/searchbiding", {
        groupName,
      });
      if (Array.isArray(response.data) && response.data.length > 0) {
        setTransactions(response.data);
      } else {
        alert("No data available.");
      }
      setError(null);
    } catch (error) {
      // console.error(error);
      setError("An error occurred. please try again.");
    }
  };

  
  useEffect(() => {
    const fetchnameData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getmemberdetails/afterlogin/${usernamedashboard}`
        );
        setuser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchnameData();
  }, [usernamedashboard]);

  const loginuserid = user.UserId;

  const loadData = async () => {
    const response = await axios.get(
      `http://localhost:5001/chit/data/get/${loginuserid}`
    );
    setData(response.data);
  };
  useEffect(() => {
    loadData();
  }, [loginuserid]);

  return (
    <div style={{ display: "flex" }}>
      <div>
        <AgentSide />
      </div>
      <div className="Pay-mm">
        <div className="Pay-display-full2">
          <div className="Pay-courses-head">
            <div className="dash-heading">
              <h2>Payment Collection </h2>
            </div>
            <div className="image">
            <div>
              <img
              src={user.uploadPhoto? `http://localhost:5001/uploads/${user.uploadPhoto}` : userimage}
                // src={`http://localhost:5001/uploads/${user.uploadPhoto}`}
                alt=""
                className="images"
              ></img>
            </div>
              <div>
                <p style={{ margin: "0px" }}>{user.UserName}</p>
                <p style={{ margin: "0px" }}>({user.role})</p>
              </div>
            </div>
          </div>

          <hr />
          <div >
            <form onSubmit={handleSearch}>
              <div className="Ad-display-002">
                <label >
                  <strong> Group Name</strong>
                </label>
                
                <Select
                  // className="Pay-input"
                  value={selectedOption}
                  onChange={(selectedOption) => {
                    setSelectedOption(selectedOption);
                    setGroupName(selectedOption ? selectedOption.value : null); // Update groupName with selected value
                  }}
                  options={data.map((opts, i) => ({
                    value: opts.groupName,
                    label: opts.groupName,
                  }))}
                  isSearchable={true}
                  placeholder="Select Group"
                />
              </div>
              <div>
                <button type="Submit" className=" Ad-up-button-10">
                  View Details
                </button>
              </div>
            </form>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="Ad-up-bgfs">
              {transactions.length > 0 ? (
                <div className="Ad-table-userpayreport">
                  <table className="Ad-table-style-Gu">
                    <thead>
                      <tr className="Adsasq">
                        <th colSpan="14" style={{ textAlign: "center" }}>
                          Transactions
                        </th>
                      </tr>
                      <tr>
                        <th className="tahe" style={{ textAlign: "center", margin: "0px" }}>
                          No.
                        </th>
                        <th className="tahe" style={{ textAlign: "center" }}>Group ID</th>
                        <th className="tahe" style={{ textAlign: "center" }}>group Name</th>
                        <th className="tahe" style={{ textAlign: "center" }}>chit Amount</th>
                        <th className="tahe" style={{ textAlign: "center" }}>No.of users</th>
                        <th className="tahe" style={{ textAlign: "center" }}>
                          installment Number
                        </th>
                        <th className="tahe" style={{ textAlign: "center" }}>commission</th>
                        <th className="tahe" style={{ textAlign: "center" }}>bid Amount</th>
                        <th className="tahe" style={{ textAlign: "center" }}>bid Winner</th>
                        <th className="tahe" style={{ textAlign: "center" }}>
                          collecting from subcriber
                        </th>
                        <th className="tahe" style={{ textAlign: "center" }}>pay to Winner</th>
                        <th className="tahe" style={{ textAlign: "center" }}>AuctionId</th>
                        <th className="tahe" style={{ textAlign: "center" }}>date</th>
                        <th className="tahe" style={{ textAlign: "center" }}>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>{transaction.id_group}</td>
                          <td style={{ textAlign: "center" }}>{transaction.name_grp}</td>
                          <td style={{ textAlign: "center" }}>{transaction.amount_chit}</td>
                          <td style={{ textAlign: "center" }}>{transaction.user_num}</td>
                          <td style={{ textAlign: "center" }}>{transaction.install_numb}</td>
                          <td style={{ textAlign: "center" }}>{transaction.comision}</td>
                          <td style={{ textAlign: "center" }}>{transaction.amount_bid}</td>
                          <td style={{ textAlign: "center" }}>{transaction.bid_winner}</td>
                          <td style={{ textAlign: "center" }}>{transaction.payoutsub}</td>
                          <td style={{ textAlign: "center" }}>{transaction.payinsub}</td>
                          <td style={{ textAlign: "center" }}>{transaction.id_auction}</td>
                          <td style={{ textAlign: "center" }}>{transaction.date}</td>
                          <td style={{ textAlign: "center" }}>
                            <Link to={`/agentpayin/${transaction.bidingId}`}>
                              <button
                               
                                className="Ad-up-home-edit"
                              >
                                Payin
                              </button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agentpaymentcollection;
